import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=982c85a0&scoped=true&"
import script from "./currency.vue?vue&type=script&lang=js&"
export * from "./currency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982c85a0",
  null
  
)

export default component.exports